import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { CampaignScreen, CampaignListScreen, CreateCampaignScreen, EditCampaignScreen } from '../screens';
import { getMenuAction } from './shared/sidebar.menu';


const Stack = createStackNavigator();

export const CampaignStack = () => (
    <Stack.Navigator>
        <Stack.Screen name='Campaigns' component={CampaignListScreen} options={{ title: 'Campaigns', ...getMenuAction(true) }} />
        <Stack.Screen name='Campaign' component={CampaignScreen} options={{ title: 'Campaign Details'}} />
        <Stack.Screen name='CreateCampaign' component={CreateCampaignScreen} options={{ title: '', headerStyle: { shadowOpacity: 0, elevation: 0 } }} />
        <Stack.Screen name='EditCampaign' component={EditCampaignScreen} options={{ title: 'Edit Campaign' }} />
    </Stack.Navigator>
);
